import {v4 as uuid } from 'uuid';
import { subscriberAPI } from './api';

async function subscribe (params) {
    const env = this.env;
    const appStore = this.env.appStore;
    const statesStore = this.env.uiStatesStore;
    const schedulesStore = this.env.schedulesStore;
    const apiKey = appStore.widgetSettings.apikey;

    appStore.gaStartSubscribe();
    const {
        selectedCalendarValue: calType,
    } = params;

    let calApplication = calType;
    if (calType === 'outlook-new') {
        calApplication = 'outlook';
    };

    const body = {
        ...statesStore.subscribersParams,
        application: calApplication,
    };

    this.cleanPayload({
        body,
        appStore,
        env,
        schedulesStore,
    });

    const res = await subscriberAPI({
        apiKey,
        body,
        widgetId: appStore.widget.id,
        traceId: env.traceId,
        store: this,
    });
    
    // process res..
    // console.log('subscriberStore.subscribe() Res: -> ', res);

    const subscriberId = res.data.subscriberId;
    if (res.data.subscriberId) {
        appStore.subscriberId = subscriberId;
        appStore.calendarURL = res.data.calendarURL;
        appStore.observed.calendarURL = uuid();
        const csParams = {
            id: subscriberId,
            user_type: 'new',
            calendar_type: calType,
            application: calApplication,
            calendar_ids: statesStore.subscribersParams.calendarIds,
        };

        if (appStore.autoSubscribe) {
            csParams.calendar_ids = schedulesStore.allScheduleIds;
        }

        if (appStore.skip_schedule_selection) {
            // remove calendar_ids on schedule Selection
            delete csParams.calendar_ids;
        }
        await this.completeSubscription(csParams);
    }

}

export default subscribe;